const athletes = state => state.athletes;

const athlete = state => state.athlete;

const athleteLoading = state => state.athleteLoading;

const athletesLoading = state => state.athletesLoading;

const athleteMeta = state => state.meta;

const profileViews = state => state.profileViews;

const athleteEvents = state => state.athleteEvents;

const athleteVideos = state => state.athleteVideos;

const athleteImageUpload = state => state.athleteImageUpload;

const athleteImageUploadLoading = state => state.athleteImageUploadLoading;

const deleteAthleteImages = state => state.deleteAthleteImages;

const deleteAthleteImagesLoading = state => state.deleteAthleteImagesLoading;

const athleteTeamPlayed = state => state.athleteTeamPlayed;

const athleteTeamPlayedLoading = state => state.athleteTeamPlayedLoading;

const profileViewMeta = state => state.profileViewMeta

export default {
  athletes,
  athlete,
  athleteLoading,
  athletesLoading,
  athleteMeta,
  profileViews,
  athleteVideos,
  athleteEvents,
  athleteImageUpload,
  athleteImageUploadLoading,
  deleteAthleteImages,
  deleteAthleteImagesLoading,
  athleteTeamPlayed,
  athleteTeamPlayedLoading,
  profileViewMeta
};
